import { render, staticRenderFns } from "./EditSpecificRights.vue?vue&type=template&id=5538d51c&"
import script from "./EditSpecificRights.vue?vue&type=script&lang=js&"
export * from "./EditSpecificRights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports